export default "__VITE_ASSET__BUvN1p3t__"